import React, { PureComponent } from 'react';
//import PropTypes from 'prop-types';
import {
    Form, Input,Button,
    message,
} from 'antd';

class SheaderForm extends PureComponent {

    state = {

    }

    componentDidMount = () => {
        let defConfig = JSON.parse(localStorage.getItem('configApp'));
        this.setState(defConfig);
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.setState({
                    header: values.nama_rs
                }, () => this.saveToLocal());
                message.success("Setting Tersimpan.");
            }
        });
    }

    saveToLocal = () => {
        let defConfig = JSON.parse(localStorage.getItem('configApp'));
        
        let newConfig = Object.assign({}, defConfig, {
            header: this.state.header
        });

        localStorage.setItem('configApp', JSON.stringify(newConfig));
    }

    render() {
        const { getFieldDecorator } = this.props.form;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 16,
                    offset: 8,
                },
            },
        };
        return (
            <div>
                <Form onSubmit={this.handleSubmit} hideRequiredMark>
                    <Form.Item {...formItemLayout} label="Nama RS">
                        {getFieldDecorator('nama_rs', {
                            rules: [{
                                required: true, message: 'Nama Rumah Sakit Tidak Boleh Kosong!',
                            }],
                            initialValue: this.state.header
                        })(
                            <Input />
                        )}
                    </Form.Item>
                    <Form.Item {...tailFormItemLayout}>
                        <Button type="primary" htmlType="submit">Terapkan</Button>
                    </Form.Item>
                </Form>
            </div>
        );
    }
}

const WrappedSheaderForm = Form.create({ name: 'sheader' })(SheaderForm);

SheaderForm.propTypes = {

};

export default WrappedSheaderForm;